// hooks/useWhatsappNotifications.js
import { useState, useCallback } from 'react';
import { getNotificationHistory, retryNotifications, updatePassengerPhone } from '../../api/whatsapp/whatsappService';

export const useWhatsappNotifications = (manifestId) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchHistory = useCallback(async (passengerId = null) => {
        setLoading(true);
        setError(null);
        try {
            const data = await getNotificationHistory(manifestId, passengerId);
            return data;
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.message || 'Error al cargar el historial';
            setError(errorMsg);
            throw new Error(errorMsg);
        } finally {
            setLoading(false);
        }
    }, [manifestId]);

    const retryFailed = useCallback(async (passengerId = null) => {
        setLoading(true);
        setError(null);
        try {
            const result = await retryNotifications(manifestId, passengerId);
            return result;
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.message || 'Error al reenviar notificaciones';
            setError(errorMsg);
            throw new Error(errorMsg);
        } finally {
            setLoading(false);
        }
    }, [manifestId]);

    const updatePhone = useCallback(async (perId, phone) => {
        setLoading(true);
        setError(null);
        try {
            const result = await updatePassengerPhone(perId, phone);
            return result;
        } catch (err) {
            const errorMsg = err.response?.data?.error || err.message || 'Error al actualizar el teléfono';
            setError(errorMsg);
            throw new Error(errorMsg);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        error,
        fetchHistory,
        retryFailed,
        updatePhone,
    };
};